import Axios from 'axios';
import { ROUTES } from 'constants/routes';
import { parse, stringify } from 'qs';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

type Props = {
    history: any;
    location: any;
    match: any;
    liftEventInfo?: (event: any) => void;
    error: any;
    isPending: boolean;
    redirect?: boolean;
    config?: any;
};

class Initialize extends React.Component<RouteComponentProps<{}> & Props, any> {
    public componentDidMount() {
        const { location } = this.props
        const params = parse(location.search, { ignoreQueryPrefix: true })

        Axios.get('/self-auth/initialize', {
            params,
            paramsSerializer: p => stringify(p)
        }).then(res => {
            // Here goes the form
            let route;
            if (res.status === 200) {
                route = ROUTES.SELF_SERVICES
            } else if (res.status === 204) {
                route = ROUTES.AUTHENTICATION
            } else {
                route = ROUTES.ERROR
            }
            this.props.history.push(route);
        }).catch(err => {
            // Here goes the error
            this.props.history.push(ROUTES.ERROR);
        })
    }
    public render() {
        return (
            <div />
        )
    }
}

export default withRouter<Props, any>(Initialize);